import * as Styled from './styled';

const HeadlineInput = Styled.HeadlineInput;

export default HeadlineInput;
